export default function CheckIcon({className = ''}: {className?: string}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M9.707 16.293 5.414 12l1.414-1.414 2.879 2.879 7.465-7.465L18.586 7.5l-8.879 8.793Z" />
    </svg>
  )
}
